import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import QUERY, {
	type EcosystemBackgroundScriptsWithLoaderQuery,
} from '@jira/ecosystem__forge-connect-background-scripts/src/__generated__/EcosystemBackgroundScriptsWithLoaderQuery.graphql.ts';

import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

import type { RouteResource } from '@atlassian/react-resource-router';

export const ecosystemConnectBackgroundScriptsResource: RouteResource<
	PreloadedQuery<EcosystemBackgroundScriptsWithLoaderQuery, Record<string, unknown>>
> = createRelayResource<EcosystemBackgroundScriptsWithLoaderQuery>({
	type: 'ECOSYSTEM_CONNECT_BACKGROUND_SCRIPTS',
	getQuery: ({ match, query }, { tenantContext }) => {
		const issueKey = getIssueKey(match) || query?.selectedIssue || '';

		if (!issueKey) {
			return {
				parameters: QUERY,
				variables: {
					cloudId: '',
					issueKey: '',
				},
				options: { fetchPolicy: 'store-only' },
			};
		}

		return {
			parameters: QUERY,
			variables: {
				cloudId: tenantContext?.cloudId || '',
				issueKey,
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
	isBrowserOnly: false,
});
